import React, { FC } from 'react';
import { t } from 'i18next';

import UDatePicker from 'Components/unit/UDatePicker/UDatePicker';
import { COLORS } from 'Components/foundation';

import { sharedPanelFormStyles } from '../SchedulePanel.style';

export type ScheduleLaunchDateFormProps = {
  launchDate: string;
  disabled?: boolean;
  onDateChange: (date: string) => void;
};

export const ScheduleLaunchDateForm: FC<ScheduleLaunchDateFormProps> = ({ launchDate, disabled, onDateChange }) => {
  const handleDateChange = (date: Date) => onDateChange(date.toISOString().split('T')[0]);

  return (
    <div style={sharedPanelFormStyles.box}>
      <h4 style={sharedPanelFormStyles.title}>{t('activities:scheduling.side_panel.launch_date')}</h4>
      <div style={sharedPanelFormStyles.element}>
        <UDatePicker
          date={new Date(launchDate)}
          disabled={disabled}
          onClick={handleDateChange}
          style={{
            border: '1px solid',
            borderColor: COLORS.GREY_MEDIUM.DEFAULT,
            zIndex: 2,
          }}
        />
      </div>
    </div>
  );
};
